export default __webpack_public_path__ + "static/media/canara.49f50374.png";